
export function getPrintLayerWmts(kvLayer, layer) {

    let serviceUrl = kvLayer.Url

    try {
        new URL(serviceUrl);
    } catch (_) {
        serviceUrl = window.kaartViewerUrl + serviceUrl
    }

    let printLayer = {}
    if (serviceUrl[serviceUrl.length - 1] === '/') {
        serviceUrl = serviceUrl.slice(0, -1) + '?'
    }

    const layerUrl = layer.getSource().getUrls()[0]
    let requestEncoding = 'KVP'
    if(layerUrl.includes('{TileMatrixSet}')) {
        serviceUrl = layerUrl
        requestEncoding = 'REST'
    }

    printLayer.baseURL = serviceUrl
    printLayer.type = 'WMTS'
    printLayer.requestEncoding = requestEncoding

    printLayer.matrixSet = kvLayer.Service.Projection
    if(kvLayer.Service.Projection === 'GoogleMapsVL') {
        printLayer.matrixSet = 'GoogleMapsVL'
    }

    console.log(kvLayer, layer)

    printLayer.style = kvLayer.Styles[0]
    printLayer.version = '1.0.0'
    printLayer.opacity = 1
    printLayer.singleTile = false
    printLayer.layer = kvLayer.Layer
    printLayer.format = 'image/png'
    printLayer.imageFormat = 'image/png'
    printLayer.sorting = kvLayer.zIndex

    return printLayer
}
